import { createContext, useContext, useRef, useState } from 'react';

// Create a Context
const DiceContext = createContext();

// Custom hook to use the UserContext
export const useDice = () => {
    return useContext(DiceContext);
};

const dice = {
    'D4': 4,
    'D6': 6,
    'D8': 8,
    'D10': 10,
    'D12': 12,
    'D20': 20,
    'D100': 100,
}

// Provider component
export const DiceProvider = ({ children }) => {
    const [diceResults, setDiceResults] = useState([]);
    const [selectedDice, setSelectedDice] = useState({});
    const [isRolling, setIsRolling] = useState(false);
    const rollingRef = useRef(false);

    const textRoll = (rollText, rollType) => {
        rollText = rollText.replace(/\s+/g, '');
        const rollMatch = rollText.match(/^(\d+)?\s*(d\d+)(?:\s*([+-]?\d+))?$/i);
        if (!rollMatch) {
            return;
        }

        const [, numberOfDice, diceKey, modifierValue] = rollMatch;
        const rollMod = modifierValue ? parseInt(modifierValue) : 0;

        const diceToRoll = { [diceKey.toUpperCase()]: parseInt(numberOfDice) };
        rollDice(diceToRoll, rollMod, rollType)
    }

    const rollDice = (textDice=null, rollMod = 0, rollType = null) => {
        let diceToRoll = selectedDice
        if(textDice)
            diceToRoll = textDice

        const groups = Object.entries(diceToRoll).map(([diceKey, count]) => {
            const rolls = Array.from({ length: count }, () => (
                Math.floor(Math.random() * dice[diceKey]) + 1
            ));

            return {
                notation: `${count === 1 ? "" : count}${diceKey}`,
                total: rolls.reduce((sum, value) => sum + value, 0) + rollMod,
                rollResults: rolls.join(' + '),
                diceMax: dice[diceKey],
            };
        });

        if (groups.length > 0) {
            const result = {
                notation: groups.map(group => group.notation).join(', '),
                total: groups.reduce((sum, group) => sum + group.total, 0),
                groups,
                diceMax: groups[0].diceMax,
                rollMod: parseInt(rollMod),
                rollType: rollType
            };

            rollingRef.current = true;
            setIsRolling(true);
            setDiceResults(current => [result, ...current]);

            let rollTime = 1000
            setTimeout(() => {
                rollingRef.current = false;
                setIsRolling(false);
            }, rollTime);

            if(!textDice)
                setSelectedDice({});
        }
    }

    return (
        <DiceContext.Provider 
            value={{ 
                diceResults, setDiceResults,
                selectedDice, setSelectedDice,
                rollDice, textRoll, isRolling
            }}
        >
            {children}
        </DiceContext.Provider>
    );
};